export default __webpack_public_path__ + "static/650-d24308096b0d89917fd8f15ce86fb600.gif";